import store from "../store";
import Vue from "vue";

let Socket: WebSocket | null = null;
let token = "";
let URL = "";
let isAuth = false;

interface Message {
  content: string;
}

interface SendFormat {
  Event: string;
  Content?: string | null;
}

interface ResponseFormat {
  event: string;
  content: null;
}

const onOpen = (e: Event) => {
  if (!Socket) return;
  console.log(e);
  const data: SendFormat = {
    Event: "authorization",
    Content: token
  };
  Socket.send(JSON.stringify(data));
  isAuth = true;
};

const onError = (e: Event) => {
  console.log(e);
  isAuth = false;
  Socket?.close();
};

const onClose = () => {
  if (!Socket) return;
  isAuth = false;
  Socket.close();
};

export const disconnectWS = () => {
  if (!Socket) return;
  isAuth = false;
  Socket.close();
};

const onMessage = (e: MessageEvent) => {
  const res = JSON.parse(e.data);
  console.log("recv:");
  console.log(res);
  if (res.event === "notification") {
    store.commit("user/setUserNotification", true, { root: true });
  } else if (res.event === "initialMessage") {
    store.dispatch("contact/initialMessage", res.content);
    //store.commit("contact/setMessages", res.content, { root: true });
  } else if (res.event === "recvMessage" || res.event === "sendMessage") {
    //console.log(res.Content);
    store.commit("contact/pushMessage", res.content, { root: true });
  } else if (res.event === "scrollMessage") {
    store.dispatch("contact/scroolMessage", res.content);
    //store.commit("contact/pushMessages", res.content, { root: true });
  }
};

export const createSocket = (url: string) => {
  if (!Socket || Socket.CLOSED) {
    URL = url;
    token = Vue.cookies.get("token") as string;
    console.log("create websocket");
    Socket = new WebSocket(url);
    Socket.onopen = onOpen;
    Socket.onmessage = onMessage;
    Socket.onerror = onError;
    Socket.onclose = onClose;
  } else {
    console.log("already connected");
  }
};

const connecting = (content: SendFormat) => {
  setTimeout(() => {
    if (Socket?.readyState === 0) {
      connecting(content);
    } else {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      sendWS(content);
    }
  }, 1000);
};

export const sendWS = (content: SendFormat) => {
  //debugger;
  if (
    !Socket ||
    Socket.readyState === Socket.CLOSED ||
    Socket.readyState === Socket.CLOSING
  ) {
    isAuth = false;
    Socket?.close();
    createSocket(URL);
    sendWS(content);
  } else if (Socket.readyState === Socket.CLOSING) {
    connecting(content);
  } else if (Socket.readyState === Socket.OPEN) {
    if (!isAuth) {
      sendWS(content);
      return;
    }
    console.log("send:");
    console.log(content);
    Socket.send(JSON.stringify(content));
  } else if (Socket.readyState === Socket.CONNECTING) {
    connecting(content);
  }
};
